(function () {
  const DRAWER_ID = 'MobileDrawer';
  const TRIGGER_SELECTOR = '[data-mobile-nav-trigger]';
  const CLOSE_SELECTOR = '[data-mobile-drawer-close]';
  const ACCORDION_TRIGGER = '[data-mobile-drawer-accordion-trigger]';
  const FOCUSABLE = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  let drawer, trigger, lastFocused;

  function init() {
    drawer = document.getElementById(DRAWER_ID);
    trigger = document.querySelector(TRIGGER_SELECTOR);
    if (!drawer || !trigger) return;

    // Drawer ans Body-Ende verschieben, damit inert-Vererbung vom Section-Wrapper ihn nicht deaktiviert.
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    trigger.addEventListener('click', open);
    const closeBtn = drawer.querySelector(CLOSE_SELECTOR);
    if (closeBtn) closeBtn.addEventListener('click', close);
    document.addEventListener('keydown', handleKeydown);

    drawer.querySelectorAll(ACCORDION_TRIGGER).forEach(function (btn) {
      btn.addEventListener('click', toggleAccordion);
    });
  }

  function open() {
    lastFocused = document.activeElement;
    drawer.classList.add('mobile-drawer--open');
    drawer.removeAttribute('aria-hidden');
    trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    setInertOnSiblings(true);

    requestAnimationFrame(function () {
      const closeBtn = drawer.querySelector(CLOSE_SELECTOR);
      if (closeBtn) closeBtn.focus();
    });
  }

  function close() {
    drawer.classList.remove('mobile-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    setInertOnSiblings(false);

    if (lastFocused && typeof lastFocused.focus === 'function') {
      lastFocused.focus();
    }
  }

  function setInertOnSiblings(active) {
    // Drawer ist Kind von <body>. Setze inert auf alle Geschwister.
    Array.prototype.forEach.call(document.body.children, function (el) {
      if (el === drawer) return;
      if (active) {
        el.setAttribute('inert', '');
      } else {
        el.removeAttribute('inert');
      }
    });
  }

  function handleKeydown(e) {
    if (!drawer.classList.contains('mobile-drawer--open')) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      close();
      return;
    }

    if (e.key === 'Tab') {
      trapFocus(e);
    }
  }

  function trapFocus(e) {
    const focusables = Array.prototype.filter.call(
      drawer.querySelectorAll(FOCUSABLE),
      function (el) { return !el.closest('[hidden]'); }
    );
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function toggleAccordion(e) {
    const btn = e.currentTarget;
    const expanded = btn.getAttribute('aria-expanded') === 'true';
    const targetId = btn.getAttribute('aria-controls');
    const target = document.getElementById(targetId);
    if (!target) return;

    btn.setAttribute('aria-expanded', String(!expanded));
    if (expanded) {
      target.setAttribute('hidden', '');
    } else {
      target.removeAttribute('hidden');
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
